import React from 'react';
import Skeleton from 'Components/DesignSystem/Skeleton/Skeleton';
import { useConfigurationContext } from './Context/ConfigurationContext';
import { MappingTable } from './MappingTable';
import InfoTooltip from 'Components/DesignSystem/Tooltip/InfoTooltip';
import FieldTitle from 'Components/DesignSystem/FieldTitle/FieldTitle';

type ProductsTabProps = {
  id?: string;
};

export const ProductsTab = ({ id = 'products-tab' }: ProductsTabProps) => {
  const { currentConfig, isLoading } = useConfigurationContext();

  if (isLoading) {
    return (
      <div data-testid={`${id}-loading`}>
        <div
          className="tw-flex tw-flex-col tw-gap-2"
          data-testid={`${id}-skeleton-container`}
        >
          {[0, 1, 2, 3, 4].map((index) => (
            <Skeleton
              key={index}
              variant="rect"
              height="36px"
              data-testid={`${id}-skeleton-${index}`}
            />
          ))}
        </div>
      </div>
    );
  }

  if (!currentConfig?.product) return null;

  return (
    <div data-testid={id}>
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
        {/* `tw-text-slate-500` was off-palette — Tailwind's own slate, not a DS ink. */}
        <FieldTitle label="Mapping" />
        <InfoTooltip
          placement="right"
          label="About product field mapping"
          message={
            <div>
              <p>Configure how product data from the connector maps to Smart Studio.</p>
              <p>Choose Source type and Value for each field:</p>
              <ul className="tw-mt-2 tw-list-disc">
                <li>Attribute: Connector data field</li>
                <li>Field: Smart Studio field</li>
                <li>Fixed Value: Static value (pre-filled)</li>
              </ul>
            </div>
          }
        />
      </div>
      <MappingTable
        id={`${id}-mapping-table`}
        mappings={currentConfig.product}
      />
    </div>
  );
};